module.exports = "../fonts/SFUIText-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Regular.ttf
// module id = 571
// module chunks = 0